import { render, staticRenderFns } from "./PublicStudi.vue?vue&type=template&id=67f90f9b"
import script from "./PublicStudi.vue?vue&type=script&lang=js"
export * from "./PublicStudi.vue?vue&type=script&lang=js"
import style0 from "./PublicStudi.vue?vue&type=style&index=0&id=67f90f9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports